import { Meta } from '@storybook/addon-docs/blocks';

<Meta title="Overview/Guiding Principles" />

# Guiding Principles

* It should be easy to use these web components in decoupled Drupal projects with API data provided by Drupal Core.
* It should also be possible to use these same components within Drupal's traditional Twig based templating engine.
* While additional components may be contributed, this project will primarily focus on creating components following along with [related strategic Drupal initiatives](https://www.drupal.org/project/decoupled_menus_initiative).
